<template>
  <footer class="footer py-4">
    <div class="container">
      <div class="row align-items-center">
        <div class="col-lg-4 text-lg-left">
          Copyright &copy; SandBox Power 2021
        </div>
        <div class="col-lg-4 my-3 my-lg-0">
          <a class="mr-3" href="#hero">Back to Top</a>
        </div>
        <div class="col-lg-4 text-lg-right">
          Thank you for your supports!
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: "Footer"
}
</script>

<style scoped>

</style>